module.exports = "<div class=\"modal-body\">\n  Please Wait\n</div>\n"